var tmrAuto = [], tmrSlide = [], items = [], prev = [];

function detectGlobalSwipes() {
	// general touch events
	window.currentY = null;
	window.currentX = null;
	window.lastX = null;
	window.lastY = null;

	document.addEventListener("touchstart", function (e) {
		window.currentY = e.touches[0].clientY;
		window.currentX = e.touches[0].clientX;
	}, false);
	document.addEventListener("touchmove", function (e) {
		window.lastY = e.touches[0].clientY;
		window.lastX = e.touches[0].clientX;
	}, false);
}

function slideTo(config) {
	var slider = config.slider,
		index = config.index,
		callback = config.callback || function () {},
		direction = config.direction || 1,
		paginators = slider.parentNode.querySelectorAll(".slider-paginator .slider-index"),
		speed = parseInt(slider.getAttribute("data-slider-speed"), 10),
		sliderPrevPos = parseInt(slider.getAttribute("data-slider-position"), 10),
		sliderIndex = parseInt(slider.getAttribute("data-slider-index"), 10);

	if (index !== sliderPrevPos) {
		prev[sliderIndex] = sliderPrevPos;
		slider.setAttribute("data-slider-position", index);
		slider.classList.remove("left");
		slider.classList.remove("right");

		if (sliderPrevPos < index) {
			slider.classList.add("right");
		} else {
			slider.classList.add("left");
		}

		[].forEach.call(items[sliderIndex], function(item, i) {
			item.classList.remove("active");
			item.classList.remove("leaving");
		});

		items[sliderIndex][prev[sliderIndex]].classList.add("leaving");
		items[sliderIndex][index].classList.add("active");

		[].forEach.call(paginators, function(paginator, i) {
			(i === index) ? paginator.classList.add("active") : paginator.classList.remove("active");
		});

		clearTimeout(tmrSlide[sliderIndex]);
		tmrSlide[sliderIndex] = setTimeout(function () {
			[].forEach.call(items[sliderIndex], function(item, i) {
				item.classList.remove("leaving");
			});
		}, speed);
	}

	callback({
		slider: slider,
		index: index
	});
}

function slideNext(slider, callback) {
	var index = parseInt(slider.getAttribute("data-slider-position"), 10),
		length = slider.querySelectorAll(".slider-item").length;
	if (index < length - 1) {
		slideTo({slider: slider, index: ++index, callback: callback});
	} else {
		slideTo({slider: slider, index: 0, callback: callback});
	}
}

function slidePrev(slider, callback) {
	var index = parseInt(slider.getAttribute("data-slider-position"), 10),
		length = slider.querySelectorAll(".slider-item").length;
	if (index === 0) {
		slideTo({slider: slider, index: length - 1, callback: callback});
	} else {
		slideTo({slider: slider, index: --index, callback: callback});
	}
}

function swipesGestures(slider) {
	slider.addEventListener("touchend", function (e) {
		if (window.currentX - window.lastX > 80 && window.lastX !== null) {
			disableTimer(slider);
			slideNext(slider);
		} else if (window.currentX - window.lastX < -80 && window.lastX !== null) {
			disableTimer(slider);
			slidePrev(slider);
		}
	}, false);
}

function autoTimer(slider, timer, callback) {
	var sliderIndex = parseInt(slider.getAttribute("data-slider-index"), 10);
	tmrAuto[sliderIndex] = setInterval(function () {
		slideNext(slider, callback);
	}, timer);
}

function disableTimer(slider) {
	var sliderIndex = parseInt(slider.getAttribute("data-slider-index"), 10);
	clearInterval(tmrAuto[sliderIndex]);
}

export default function slider(elem, config) {
	var config = config || {},
		timer = config.timer || 3000,
		speed = config.speed || 500,
		callback = config.callback;

	detectGlobalSwipes();

	[].forEach.call(elem, function(slider, index) {
		var style = document.createElement('style'),
			container, paginators, numItems;

		style.type = 'text/css';
		style.innerHTML = "[data-slider-index=\"" + index + "\"] .slider-item.leaving, [data-slider-index=\"" + index + "\"] .slider-item.active { transition: all " + speed + "ms; }";
		document.querySelector('head').appendChild(style);
    	
    	if (slider.getAttribute("initialized") === "true") {
    		slideTo({slider: slider, index: 0, callback: callback});
    		return;
    	}

    	items[index] = slider.querySelectorAll(".slider-item");
    	items[index][0].classList.add("active");
    	numItems = items[index].length;

    	slider.setAttribute("data-slider-position", 0);
    	slider.setAttribute("data-slider-speed", speed);
    	slider.setAttribute("data-slider-index", index);

    	container = slider.parentNode;
    	paginators = container.querySelectorAll(".slider-paginator .slider-index");

		[].forEach.call(paginators, function(paginator) {
			paginator.onclick = function (e) {
				e.stopPropagation();
				e.preventDefault();
				disableTimer(slider);
				slideTo({slider: slider, index: parseInt(this.getAttribute("data-index"), 10), callback: callback});
			}
		});
		autoTimer(slider, timer, callback);
		swipesGestures(slider);
    	slider.setAttribute("initialized", "true");
	});
	
}




//////////////////
// WEBPACK FOOTER
// ./src/js/components/slider.js
// module id = 8
// module chunks = 0